<template>
  <!-- 解决方案 -->
  <div class="Solution" v-loading="loading">
    <div class="cpzx_bj">
      <img src="@/assets/img/spzx_xqy/banner-bg.png" alt="" />
      <ul class="cpzx_bj_text">
        <li>解决方案</li>
        <li>绿色生态产业链全方位数据专家</li>
        <li></li>
      </ul>
    </div>
    <div class="breadcrumb">
      <div class="breadcrumbBox">
        <img src="@/assets/img/spzx/cpzx_home.png" alt="" />
        <div class="breadcrumbBox_text">
          <span>首页&nbsp;></span>
          <span>解决方案</span>
        </div>
      </div>
    </div>
    <div class="Solution_box" id="main-content">
      <div class="contentBox">
        <div class="toggleBar">
          <div class="toggleBar_box">
            <button
              class="toggleBar_box_btn"
              v-for="(item, index) in buttonArr"
              :key="index"
              @click="toggleBarClick(item)"
              :class="[toggleBarValue === item ? 'btnStyleChange' : '']"
            >
              {{ item }}
            </button>
          </div>
        </div>
        <div class="itemBox">
          <template v-if="tableData.length > 0">
            <div
              class="item"
              v-for="(item, index) in tableData"
              :key="index"
              @click="goPage(item)"
            >
              <img :src="item.imgUrl" alt="" />
              <div class="itemText">
                {{ item.name }}
              </div>
            </div>
          </template>
          <div v-else class="noData">
            暂无数据
          </div>
        </div>
        <el-pagination
          class="page"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="[6, 12, 18, 36]"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Plan from '@/api/plan.js'

export default {
  name: 'Solution',
  data () {
    return {
      buttonArr: ['全部', '软件方案', '硬件方案', '防治方案'],
      toggleBarValue: '全部',
      type: null, // 1=软件，2=硬件，3=防治方案
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 6,
      loading: false
    }
  },
  watch: {
    // 监听路由变化，当从首页跳转或手动修改URL时重新加载
    '$route': {
      handler () {
        this.initFromRouteParams()
        this.page = 1
        this.getList()
      },
      immediate: false
    }
  },
  methods: {
    // 从路由参数解析类型，设置对应的tab和type
    initFromRouteParams () {
      const { type } = this.$route.query
      if (type) {
        const typeNum = parseInt(type)
        if (typeNum === 1) {
          this.toggleBarValue = '软件方案'
          this.type = 1
        } else if (typeNum === 2) {
          this.toggleBarValue = '硬件方案'
          this.type = 2
        } else if (typeNum === 3) {
          this.toggleBarValue = '防治方案'
          this.type = 3
        } else {
          this.resetToAll()
        }
      } else {
        this.resetToAll()
      }
    },
    // 重置为全部
    resetToAll () {
      this.toggleBarValue = '全部'
      this.type = null
    },
    // 点击tab切换（保持原有逻辑，并重置页码）
    toggleBarClick (item) {
      this.toggleBarValue = item
      if (this.toggleBarValue === '全部') {
        this.type = null
      } else if (this.toggleBarValue === '软件方案') {
        this.type = 1
      } else if (this.toggleBarValue === '硬件方案') {
        this.type = 2
      } else {
        this.type = 3
      }
      this.page = 1 // 重置到第一页
      this.getList()
    },
    goPage (item) {
      if (item && item.id) {
        this.$router.push({
          name: 'SolutionDetails',
          query: {
            planDataCenterId: item.id.toString()
          }
        })
      } else {
        this.$message.error('解决方案数据异常，无法查看详情')
      }
    },
    async getList () {
      this.loading = true
      const params = {
        name: '',
        startTime: '',
        endTime: '',
        page: this.page,
        pageSize: this.pageSize,
        type: this.type,
        startStatus: 1
      }
      const { code, msg, data, total } = await Plan.queryAcList(params)
      if (code === 200) {
        const enabledCategories = data.filter(item => item.startStatus === 1)
        this.tableData = enabledCategories
        this.total = total
      } else {
        this.$message.error(msg)
      }
      this.loading = false
    },
    handleCurrentChange (page) {
      this.page = page
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.page = 1
      this.getList()
    }
  },
  mounted () {
    // 初始化：从路由参数加载
    this.initFromRouteParams()
    this.getList()

    // 页面加载后自动滚动到主要内容区域
    // this.$nextTick(() => {
    //   const mainContent = document.getElementById('main-content')
    //   if (mainContent) {
    //     const breadcrumb = document.querySelector('.breadcrumb')
    //     const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 48
    //     const bannerHeight = 274
    //     window.scrollTo({
    //       top: bannerHeight + breadcrumbHeight - 10,
    //       behavior: 'smooth'
    //     })
    //   }
    // })
  }
}
</script>

<style scoped lang="scss">
.Solution {
  width: 100%;
  .cpzx_bj {
    width: 100%;
    height: 274px;
    position: relative;
    img {
      width: 100%;
      height: 274px;
    }
    .cpzx_bj_text {
      width: 310px;
      height: 134px;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -155px;
      li {
        color: #fff;
        &:nth-child(1) {
          width: 100%;
          height: 56px;
          font-size: 30px;
          padding-left: 68px;
        }

        &:nth-child(2) {
          width: 100%;
          height: 24px;
          font-size: 18px;
        }
        &:nth-child(3) {
          width: 220px;
          height: 4px;
          background-color: #fff;
          margin-top: 22px;
          margin-left: 16px;
          position: relative;
          &:after {
            content: "";
            width: 60px;
            height: 10px;
            background-color: #fff;
            position: absolute;
            top: -3px;
            left: 80px;
          }
        }
      }
    }
  }
  .breadcrumb {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    // border: 1px solid red;

    .breadcrumbBox {
      width: 1206px;
      height: 48px;
      font-family: Source Han Sans CN;
      display: flex;
      align-items: center;
      position: relative;
      margin-left: 14px;

      img {
        width: 22px;
        height: 20px;
      }

      .breadcrumbBox_text {
        position: absolute;
        top: 17px;
        left: 40px;
      }

      span {
        font-size: 16px;

        &:nth-child(1) {
          color: #666666;
        }

        &:nth-child(2) {
          color: #2b8737;
        }
      }
    }
  }
  .Solution_box {
    width: 100%;
    background-color: #f5f5f5;
    padding: 36px 0;
    display: flex;
    justify-content: center;
    .contentBox {
      width: 1206px;
      .toggleBar {
        width: 100%;
        height: 52px;
        padding: 0 40px;
        display: flex;
        justify-content: center;
        .toggleBar_box {
          width: 850px;
          height: 52px;
          display: flex;
          justify-content: space-between;

          .toggleBar_box_btn {
            border-color: transparent;
            background-color: #ffffff;
            color: #999999;
            font-size: 18px;
            font-weight: 400;
          }
          .btnStyleChange {
            background-color: #2b8737;
            color: #fff;
            border-color: transparent;
          }

          button {
            width: 200px;
            height: 52px;
            line-height: 52px;
            text-align: center;
            border-width: #e5e5e5;

            &:hover {
              cursor: pointer;
              opacity: 0.7;
            }
          }
        }
      }
      .itemBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .item {
          width: 390px;
          height: 286px;
          margin-top: 36px;
          margin-left: 8px;
          img {
            width: 100%;
            height: 235px;
          }
          .itemText {
            width: 100%;
            height: 51px;
            text-align: center;
            line-height: 51px;
            background-color: #fff;
          }
          &:hover {
            cursor: pointer;
            opacity: 0.7;
          }
        }
        .noData {
          width: 100%;
          text-align: center;
          margin: 50px 0;
        }
      }
      .page {
        display: flex;
        justify-content: center;
        margin: 20px 0 0 0;
      }
    }
  }
}
</style>
<style>
/* 分页组件全局样式 */
.Solution .page .el-pagination.is-background .el-pager li:not(.disabled):hover {
  background-color: #1c7e28 !important;
}

.Solution .page .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1c7e28 !important;
}

.Solution .page .el-pagination__jump .el-input__inner:focus {
  border-color: #1c7e28 !important;
}

.Solution .page .el-select .el-input.is-focus .el-input__inner {
  border-color: #1c7e28 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/solution/Solution.vue